import { Button, Modal, Table, Input } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import userActions from "../../redux/transactions/actions";
import { RiCodeSLine, RiCodeSSlashLine } from "react-icons/ri";
import { JSONTree } from "react-json-tree";
const { Search } = Input;

function Logger() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const letRef = useRef(null);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setHandleViewState({ req: false, res: false, key: "" });
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setHandleViewState({ req: false, res: false, key: "" });
  };

  const dispatch = useDispatch();

  const { getLoggerData } = userActions;
  const { loggerData } = useSelector((state) => state.transactionReducer || {});

  const [searchRefId, setSearchRefId] = useState("");
  const [debouncedRefId, setDebouncedRefId] = useState(searchRefId);
  const [pageSizeState, setPageSizeState] = useState({
    page: 1,
    pageSize: 100,
  });
  // Debounce the searchRefId by 500ms
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedRefId(searchRefId);
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [searchRefId]);

  useEffect(() => {
    dispatch(
      getLoggerData(pageSizeState.page, pageSizeState.pageSize, debouncedRefId)
    );
    // eslint-disable-next-line
  }, [pageSizeState.page, pageSizeState.pageSize, debouncedRefId]);

  const [loggerDataState, setLoggerDataState] = useState({
    data: [],
    total: 0,
    returnTotal: 0,
  });

  const [handleViewState, setHandleViewState] = useState({
    req: false,
    res: false,
    reqData: {},
    resData: {},
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleViewResponseDetails = (data, key) => {
    setHandleViewState({
      req: false,
      res: !handleViewState.res,
      key,
      resData: data,
    });
    letRef.current.click();
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleViewRequestDetails = (data, key) => {
    setHandleViewState({
      req: !handleViewState.req,
      res: false,
      key,
      reqData: data,
    });
    console.log("bug", data, key);
    letRef.current.click();
  };

  useEffect(() => {
    const dataSource = loggerData?.data?.logs?.map((item, index) => ({
      key: index,
      url: item?.url,
      message: item?.message,
      responseTime: item?.responseTime,
      requestBody: item?.requestBody && (
        <span
          onClick={() => handleViewRequestDetails(item?.requestBody, index)}
          style={{
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          {handleViewState.req && index === handleViewState.key ? (
            <RiCodeSLine size={25} />
          ) : (
            <RiCodeSSlashLine size={25} />
          )}
        </span>
      ),
      response: (item?.responseData || item?.error) && (
        <span
          onClick={() =>
            handleViewResponseDetails(item?.responseData || item?.error, index)
          }
          style={{
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          {handleViewState.res && index === handleViewState.key ? (
            <RiCodeSLine size={25} />
          ) : (
            <RiCodeSSlashLine size={25} />
          )}
        </span>
      ),
      status: item?.error?.status || "",
      createdAt: item?.createdAt,
    }));
    setLoggerDataState({
      data: dataSource || [],
      total: loggerData?.data?.total || 10,
      returnTotal: loggerData?.data?.returnItems || 10,
    });
  }, [
    handleViewRequestDetails,
    handleViewResponseDetails,
    handleViewState.key,
    handleViewState.req,
    handleViewState.res,
    loggerData,
  ]);

  const columns = [
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
    },
    {
      title: "Response Time",
      dataIndex: "responseTime",
      key: "responseTime",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Request Body",
      dataIndex: "requestBody",
      key: "requestBody",
    },
    {
      title: "Response",
      dataIndex: "response",
      key: "response",
    },
    {
      title: "Creadted At",
      dataIndex: "createdAt",
      key: "createdAt",
    },
  ];

  const onSearch = (e) => {
    console.log(e);
  };

  return (
    <>
      <div className="mx-2">
        <div className="mb-2 d-flex align-items-center justify-content-between text-2xl font-bold mb-4">
          <h1>Logger</h1>
          <div className="w-50">
            <Search
              placeholder="Search by refId"
              enterButton="Search"
              size="large"
              loading={false}
              value={searchRefId}
              allowClear
              onChange={(e) => setSearchRefId(e.target.value)}
              onSearch={(value) => {
                console.log(value, "bug");
                setPageSizeState((prev) => ({
                  ...prev,
                  page: 1,
                }));
                setSearchRefId(value);
              }}
            />
          </div>
          <div style={{ display: "none" }}>
            <Button type="primary" onClick={showModal} ref={letRef}>
              Open Modal
            </Button>
          </div>
        </div>

        <Table
          dataSource={loggerDataState.data}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={{
            current: pageSizeState.page,
            pageSize: pageSizeState.pageSize,
            total: loggerDataState.total || 0,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            showSizeChanger: true,
            pageSizeOptions: ["50", "100", "200", "500"],
            onChange: (page, pageSize) => {
              setPageSizeState({ page, pageSize });
            },
            onShowSizeChange: (current, size) => {
              setPageSizeState({ page: current, pageSize: size });
            },
          }}
        />

        <Modal
          title={handleViewState.req ? "Request" : "Response"}
          closable={{ "aria-label": "Custom Close Button" }}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <JSONTree
            data={
              (handleViewState.resData || handleViewState.reqData) !== ""
                ? handleViewState.resData || handleViewState.reqData
                : {}
            }
            theme={"bright:inverted"}
            shouldExpandNodeInitially={(index) => true}
          />
        </Modal>
      </div>
    </>
  );
}

export default Logger;
